import { Button, Group, TextInput } from "@mantine/core";
import { ILabelAndIsActive, IMultipleFilterOptions } from "@mctypes/frontend.types";
import { IconCircleCheck } from "@tabler/icons-react";
import React, { useEffect } from "react";
import { useDebounce } from "usehooks-ts";
import { ActionIcon } from "../CustomIcons/CustomIcons";
import DropdownFilter from "../DropdownFilter/DropdownFilter";

const MainFilterBar: React.FC<{
  multipleFilterItems?: IMultipleFilterOptions[];
  updateMultiFilterItemOption?: (title: string, value: string) => void;
  resetMultiFilter: (dataField) => void;
  selectAllMultiFilter?: (dataField) => void;
  booleanFilterItems?: ILabelAndIsActive[];
  updateBooleanFilterItem?: (value: string) => void;
  onUpdateSearch?: (text: string) => void;
  freeTextSearchEnabled?: boolean;
  clearAllFilters?: () => void;
}> = ({
  multipleFilterItems,
  booleanFilterItems,
  updateBooleanFilterItem,
  resetMultiFilter,
  selectAllMultiFilter,
  updateMultiFilterItemOption,
  onUpdateSearch,
  freeTextSearchEnabled = false,
  clearAllFilters,
}) => {
  const [search, setSearch] = React.useState<string>("");
  const debouncedValue = useDebounce<string>(search, 500);
  useEffect(() => {
    if (onUpdateSearch != null) {
      onUpdateSearch(debouncedValue);
    }
  }, [debouncedValue]);

  React.useEffect(() => {
    if (multipleFilterItems == null && booleanFilterItems == null) {
      alert("either multipleFilterItems or booleanFilterItems must be provided");
    }
  }, []);

  const filterHasAnFilterOptionActive = (multipleFilterOption: IMultipleFilterOptions) => {
    return multipleFilterOption.options.some((option) => option.isActive === true);
  };

  const hasActiveFilter =
    (multipleFilterItems || []).some((filterItem) => filterHasAnFilterOptionActive(filterItem)) ||
    (booleanFilterItems || []).some((booleanFilterItem) => booleanFilterItem.isActive === true);

  return (
    <>
      <Group wrap="wrap" gap={8}>
        {freeTextSearchEnabled === true && (
          <TextInput
            placeholder="Søk.."
            value={search}
            onChange={(e) => setSearch(e.currentTarget.value)}
            size="sm"
            w={150}
          />
        )}
        {(booleanFilterItems || []).map((item) => {
          return (
            <Button
              variant="outline"
              size="sm"
              px="xs"
              color={item.isActive ? "mc-primary" : "warmgray.6"}
              bg={item.isActive ? "#e8eef4" : "white"}
              onClick={() => updateBooleanFilterItem(item.label)}
              key={item.label}
              leftSection={
                <ActionIcon
                  style={{
                    scale: "0.9",
                    marginRight: "-4px",
                  }}
                />
              }
              rightSection={item.isActive ? <IconCircleCheck size={16} /> : null}
            >
              {item.label}
            </Button>
          );
        })}
        {(multipleFilterItems || []).map((option) => {
          return (
            <DropdownFilter
              key={option.title}
              enableSearch={option.options?.length > 10}
              filterOptions={option.options}
              title={option.title}
              onClick={updateMultiFilterItemOption}
              unSelectAll={resetMultiFilter != null ? () => resetMultiFilter(option.title) : null}
              selectAll={selectAllMultiFilter != null ? () => selectAllMultiFilter(option.title) : null}
            />
          );
        })}
        {hasActiveFilter && (
          <Button size="sm" px={"sm"} variant="outline" color="gray.6" onClick={clearAllFilters}>
            <i className="fa fa-close fa-fw" style={{ marginRight: "2px", marginBottom: "-2px", fontSize: ".9em" }} />
            Rens
          </Button>
        )}
      </Group>
    </>
  );
};

export default MainFilterBar;
